module.exports = "/packs/images/sprites/boroughs~4103862f78ba314211f3f9579158dcbc.png";